import { nothing } from "immer";

export const MAX_SUBTASKS = 3;

export function meal_unavailable() {}

export function forage(world, expected) {
  world.holding[expected ? "forage" : world.forageType || "forage"] = true;
}

export function chop_tree() {}
export function wait_for() {}
export function collect_gift(world, expected, source, type) { world.holding[type] = true; }
export function talk(world, expected, personId, key, aboutId, type) {
  if (key == "give_gift") world.holding[type] = false;
}

export function claim_farmable(world, expected, farmableId) {
  world.claimedFarmable = farmableId;
}

export function release_farmable(world) {
  world.claimedFarmable = null;
  world.subtasks = null;
}

export function create_stockpile(world) {
  world.no_place_for.slot = null;
}

export function create_field(world) {
  world.no_place_for.ploughable_field = null;
}

export function clear_subtasks(world) {
  world.subtasks = null;
}

export function get_attention(world, expected, targetId) {
  world.capturedAttentionOf = targetId;
}

export function release_attention(world) {
  world.capturedAttentionOf = null;
}

export function take_job(world, expected, key) {
  world.currentJob = key;
}

export function complete_job(world) {
  world.currentJob = null;
}

export function release_job(world) {
  world.currentJob = null;
}

export function walk_to(world, expected, targetId) {
  if (!targetId) {
    return nothing;
  }
}

export function set_label(world, expected, label) {
  world.label = label;
}

export function find_place(world, expected, type) {
  // NOTE: Prevent AI from looking again this hour
  if (world.days && world.no_place_for[type] != null && world.no_place_for[type] > world.days) {
    return nothing;
  }
  if (expected) {
    world.places[type] = type;
  }
}

export function pick_up_entity_with_good(world, expected, place, good) {
  world.holding[good] = true;
}

export function pick_up_from_stockpile(world, expected, place, thing) {
  world.holding[thing] = true;
}

export function drop_entity_into_stockpile_slot(world, expected, place, thing) {
  world.holding[thing] = false;
}

export function drop_entity_into_container(world, expected, place, thing) {
  world.holding[thing] = false;
}

export function pick_up_from_container(world, expected, place, thing) {
  world.holding[thing] = true;
}

export function forget_place(world, expected, type) {
  delete world.places[type];
}

export function sleep(world) {
  world.feeling.tired = false;
}

export function eat(world, expected, thing) {
  if(!expected && thing=="forage" && !world.holding.forage)thing=world.forageType || thing;
  if (!world.holding[thing]) {
    return nothing;
  }
  world.holding[thing] = false;
  if(!expected && thing=="meal"){world.holding[world.mealType]=false;delete world.mealType;}
  world.feeling.hungry = false;
}

export function create_subtasks(world, expected, targetId, result) {
  if (expected) {
    world.subtasks = Array.from({length: MAX_SUBTASKS}, (_, i) => ({ x: i, y: i, result, id: targetId }));
  }
}

export function perform_subtask_in_slot(world, expected, targetId, place, lose) {
  if (lose) {
    world.holding[lose] = false;
  }
}

export function find_next_subtask(world, expected, place) {
  if (!world.subtasks || world.subtasks.length == 0) {
    return nothing;
  }
  world.places[place] = world.subtasks[0];
}

export function complete_subtask(world, expected, place) {
  const slot = world.places[place];
  const idx = world.subtasks.findIndex(st => st.x == slot.x && st.y == slot.y);
  if (idx != -1) {
    world.subtasks.splice(idx, 1);
  }
}

export function work_shelter() {}
export function collect_log(world) { world.holding.wood = true; }
export function deliver_log(world) { world.holding.wood = false; world.holding.planks = false; }
export function carry_home() {}

export function trade_work() {}

export function socialise() {}

export function arrive_home(world) { delete world.moveHome; }
export function return_from_visit(world) { if (world.social) world.social.stage = "returning"; }
export function end_visit(world) { delete world.social; delete world.places.socialDestination; }

export function do_favour() {}
export function begin_friend_help(world, expected, offer) { world.helpingFriend = offer; }
export function help_friend_work() {}
export function end_friend_help(world) { delete world.helpingFriend; delete world.friendOffer; }

export function leave_edge() {}

export function end_world_arrival(world) { delete world.worldArrival; }

export function tend_garden(world) { delete world.gardenHelp; }
export function play_together() {}

export function home_downtime() {}

export function customs_visit() {}

export function make_meal_space() {}

export function work_field() {}
export function household_fuel() {}

export function recover_meal(world, expected) {
  world.holding.meal=true;
  if(!expected)delete world.mealSearch;
}

export function approach_chat(world, expected, targetId) { world.capturedAttentionOf=targetId; }
export function chat_visit() {}

export function settle_fire() {}
export function eat_food() {}

export function festival_wait() {}
